import { AssignedVehiclesRecord } from './AssignedVehicles.utils';

export const vehicleFieldList = [
  {
    name: 'vehicle_number',
    label: 'Vehicle Number',
  },
  {
    name: 'code',
    label: 'Vehicle Code',
  },
  {
    name: 'hub_code',
    label: 'Hub Code',
  },
  {
    name: 'vehicle_make_code',
    label: 'Vehicle Make',
  },
  {
    name: 'fleet_type',
    label: 'Fleet Type',
  },
  {
    name: 'vehicle_vendor_code',
    label: 'Vehicle Vendor',
  },
  {
    name: 'renavam_number',
    label: 'Renavam Number',
  },
  {
    name: 'state',
    label: 'State (UF)',
  },
  {
    name: 'number_of_axles',
    label: 'Number of Axles',
  },
  {
    name: 'vehicle_year',
    label: 'Vehicle Year',
  },
  {
    name: 'time_slot_start',
    label: 'Time Slot Start',
  },
  {
    name: 'time_slot_end',
    label: 'Time Slot End',
  },
  {
    name: 'working_days',
    label: 'Working Days',
  },
  {
    name: 'is_available_for_midmile',
    label: 'Available for Mid Mile',
  },
  {
    name: 'is_available_for_endpoint',
    label: 'Available for Local Trip',
  },
  {
    name: 'sensor_code',
    label: 'Sensor Code',
  },
  {
    name: 'primary_tracking_source',
    label: 'Primary Tracking Source',
  },
];

export const weekDays = [
  { label: 'Sunday', value: 0 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
];

export interface AddNewVehicleModalProps {
  handleModalClose: () => void;
  isVisible: boolean;
  action: "add" | "edit";
  vehicleData?: AssignedVehiclesRecord;
  reloadView?: () => void;
  fields_list: any[];
  vehicle_validation_strategy: Record<string, any>;
  primaryTrackingSources: any[];
}
